<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >
              แก้ไขกลุ่มความยินยอม
            </h2>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center align-start pt-5>
          <v-flex xs11 lg7 pa-5>
            <v-card>
              <v-card-title primary-title>
                ข้อมูลสำหรับแก้ไขกลุ่ม
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap justify-center align-center pa-6>
                  <v-flex xs11 lg11>
                    <b>องค์กร</b> <br />
                    {{ _BusinessName }}
                  </v-flex>
                  <v-flex xs11 lg11>
                    <b class="red--text mr-1">*</b> <b>ชื่อกลุ่ม</b> <br />
                    <v-text-field
                      outlined
                      dense
                      color="info"
                      v-model="GroupName"
                      label="ระบุชื่อกลุ่ม"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs11 lg11>
                    <span class="red--text mr-1">*</span>
                    <b>นโยบาย </b>
                    <span class="grey--text">(เลือกได้เพียง 1 นโยบาย)</span>
                  </v-flex>
                  <!-- Policy -->
                  <v-flex xs11 lg11>
                    <v-autocomplete
                      return-object
                      item-text="Title"
                      item-value="PolicyId"
                      :items="ItemPolicy"
                      v-model="SelectPolicy"
                      deletable-chips
                      color="info"
                      outlined
                      dense
                      chips
                      small-chips
                      label="เลือกนโยบาย"
                    ></v-autocomplete>
                  </v-flex>
                  <!-- example Consent-->
                  <v-flex xs11 lg11 pt-4>
                    <v-card outlined>
                      <v-card-text>
                        <b style="text-decoration: underline">ตัวอย่าง</b>
                        <div
                          v-for="(item, index) in ItemsDataSelect"
                          :key="index"
                          style="display: inline"
                        >
                          <span class="black--text pl-3 FontSize">
                            {{ item.HeaderConsent }}
                          </span>
                        </div>
                        <draggable
                          :list="ItemsDataSelect"
                          :disabled="!Enabled"
                          class="list-group move"
                          ghost-class="ghost"
                          :move="Fn_CheckMove"
                          @start="Dragging = true"
                          @end="Dragging = false"
                        >
                          <div
                            class="list-group-item"
                            v-for="(item, index) in ItemsDataSelect"
                            :key="index + 1"
                          >
                            <v-card color="#ddf7ff" class="elevation-0 ma-3">
                              <v-card-text>
                                <v-layout row wrap align-center>
                                  <v-flex xs10 lg10 text-left>
                                    <b> {{ item.HeaderConsent }}</b>
                                  </v-flex>
                                  <v-flex xs2 lg2>
                                    <v-btn
                                      color="red"
                                      fab
                                      small
                                      dark
                                      depressed
                                      @click="Fn_Delete(index)"
                                    >
                                      <v-icon>mdi-delete-outline</v-icon>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                            </v-card>
                          </div>
                        </draggable>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-layout row wrap justify-end align-center pt-5 pa-2 pb-2>
                  <v-flex xs2 lg2>
                    <v-btn block dark color="#077893" @click="Fn_CreatePolicy"
                      >บันทึก</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-flex xs11 lg4 pa-5>
            <v-card>
              <v-card-text>
                <span class="red--text mr-1">*</span>
                <b>ความยินยอม </b>
                <span class="grey--text ml-2">
                  (เลือกได้มากกว่า 1 ความยินยอม)</span
                >
              </v-card-text>
              <v-card-text>
                <v-layout row wrap justify-center align-center>
                  <v-flex xs11 lg11>
                    <v-autocomplete
                      item-text="HeaderConsent"
                      item-value="ConsentId"
                      :items="ItemConsent"
                      v-model="SelectConsent"
                      return-object
                      outlined
                      dense
                      chips
                      small-chips
                      multiple
                      label="เลือกความยินยอม"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import draggable from "vuedraggable";
import { mapGetters } from "vuex";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { draggable },
  data: function () {
    return {
      Enabled: true,
      Dragging: false,
      LoadingPolicy: false,
      ItemsData: [],
      ItemsDataSelect: [],
      ItemPolicy: [],
      ItemConsent: [],
      GroupName: "",
      Content: "",
      SelectPolicy: "",
      SelectConsent: "",
      DataConsent: [],
      PolicyId: "",
    };
  },
  computed: {
    ...mapGetters(["Business"]),
    ...mapGetters(["DataConsentGroup"]),
    ...mapGetters(["RoleAccount"]),

    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    draggingInfo() {
      return this.Dragging ? "under drag" : "";
    },
    _BusinessName: {
      get() {
        return this.DataConsentGroup.BusinessNameTh || "-";
      },
    },
    _GroupName: {
      get() {
        return this.DataConsentGroup.GroupName || "-";
      },
    },
    _GroupId: {
      get() {
        return this.DataConsentGroup.GroupId || "-";
      },
    },
  },
  mounted() {
    this.Fn_GetDataPolicy();
    this.Fn_GetDataConsent();
    this.Fn_GetDataConsentGroup();
  },
  methods: {
    Fn_CheckMove: function (e) {

    },
    Fn_AddConsent() {
      this.ItemsDataSelect = [];
      this.ItemsData = [];
      for (var i in this.SelectConsent) {
        var payload = {
          BusinessId: this.SelectConsent[i].BusinessId,
          AccountId: this.$cookies.get("OneAccountId"),
          ConsentId: this.SelectConsent[i].ConsentId,
        };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              "consent/GetDetailConsent",
            payload
          )
          .then((response) => {
            this.loadingDownloadData = false;

            if (response.data.Status === "OK") {
              this.DataConsent = response.data.Message[0];
              this.GroupSelect = {
                ConsentId: this.ConsentId,
                Level: i,
              };
              this.GroupDefault = {
                HeaderConsent: this.DataConsent.HeaderConsent,
              };
              this.ItemsData.push(this.GroupSelect);
              this.ItemsDataSelect.push(this.GroupDefault);
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.loadingDownloadData = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title:
                  this.$i18n.t("alert.contactserve") +
                  error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: this.$i18n.t("alert.contactserve") + error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title:
                  this.$t("report_instead.swal.catch_err") + error.message ||
                  error,
              });
            }
          });
      }
    },
    Fn_Delete(i) {
      this.ItemsDataSelect.splice(i, 1);
      this.ItemsData.splice(i, 1);
      this.SelectConsent.splice(i, 1);
    },
    Fn_GetDataPolicy() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "policy/GetAllDetailPolicy",
          payload
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemPolicy = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") +
                error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: this.$i18n.t("alert.contactserve") + error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title:
                this.$t("report_instead.swal.catch_err") + error.message ||
                error,
            });
          }
        });
    },
    Fn_GetDataConsent() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "consent/GetAllDetailConsent",
          payload
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemConsent = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") +
                error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: this.$i18n.t("alert.contactserve") + error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title:
                this.$t("report_instead.swal.catch_err") + error.message ||
                error,
            });
          }
        });
    },
    Fn_GetDataConsentGroup() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        GroupId: this._GroupId,
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "group-consent/GetDetailGroupConsent",
          payload
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.GroupName = response.data.Message.GroupName;
            this.GroupId = response.data.Message.GroupId;
            this.PolicyId = response.data.Message.Policy.PolicyId;
            this.SelectPolicy = response.data.Message.Policy;
            this.SelectConsent = response.data.Message.Consent;
            this.ItemsDataSelect = response.data.Message.Consent;
            this.ItemsData = response.data.Message.Consent;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") +
                error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: this.$i18n.t("alert.contactserve") + error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title:
                this.$t("report_instead.swal.catch_err") + error.message ||
                error,
            });
          }
        });
    },
    Fn_CreatePolicy() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
        GroupName: this._GroupName,
        GroupId: this._GroupId,
        PolicyId: this.SelectPolicy.PolicyId,
        Consent: this.ItemsData,
      };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "group-consent/UpdateDetailGroupConsent",
          payload
        )
        .then((response) => {
          this.loading = false;

          if (response.data.Status === "OK") {
            this.ItemPolicy = response.data.Message;
            Toast.fire({
              icon: "success",
              title: response.data.Message,
            });
            this.$router.push("/consent-management-group-index");
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") +
                error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: this.$i18n.t("alert.contactserve") + error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title:
                this.$t("report_instead.swal.catch_err") + error.message ||
                error,
            });
          }
        });
    },
    Fn_BackIndex() {
      this.$router.push("/consent-management-group-index");
    },
  },
  watch: {
    SelectConsent(val) {
      this.ItemsDataSelect = [];
      this.ItemsData = [];
      if (val) {
        var index = 0;
        for (var i in this.SelectConsent) {
          index += 1;
          this.GroupSelect = {
            GroupConsentId: this.SelectConsent[i].ConsentId,
            Level: index,
          };
          this.GroupDefault = {
            HeaderConsent: this.SelectConsent[i].HeaderConsent,
          };
          this.ItemsData.push(this.GroupSelect);
          this.ItemsDataSelect.push(this.GroupDefault);
        }
      }
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.move {
  cursor: move;
}

.FontSize {
  font-size: 14px;
}
</style>
